import { useMutation, useQuery } from "@tanstack/react-query";
import { JournalApi } from "../../routes/Journal/journal";
import { apiLogger } from "../../Utils/logger";

export const useGetJournalDetail = (journalId) => {
  return useQuery({
    queryKey: ["journalDetail", journalId],
    queryFn: async () => {
      try {
        apiLogger.apiRequest("GET", `/user-journals/${journalId}/details`);
        const response = await JournalApi.getJournalDetail(journalId);
        apiLogger.apiResponse(
          "GET",
          `/user-journals/${journalId}/details`,
          response,
          200,
        );

        // Extract the data from response.data.data (following the old pattern)
        return response?.data || response;
      } catch (error) {
        apiLogger.apiError(
          "GET",
          `/user-journals/${journalId}/details`,
          error,
          error.response?.status,
        );
        throw error;
      }
    },
  });
};

export const useGetSharePdfUrl = () => {
  return useMutation({
    mutationFn: async (payload) => {
      try {
        apiLogger.apiRequest(
          "POST",
          `/user-journals/generate-share-url`,
          payload,
        );
        const response = await JournalApi.generateSharePdfUrl(payload);
        apiLogger.apiResponse(
          "POST",
          `/user-journals/generate-share-url`,
          response.data,
          200,
        );
        return response.data;
      } catch (error) {
        apiLogger.apiError(
          "POST",
          `/user-journals/generate-share-url`,
          error,
          error.response?.status,
        );
        throw error;
      }
    },
  });
};

export const useGetCustomJournalDetail = (payload) => {
  return useMutation({
    mutationFn: async (payload) => {
      try {
        apiLogger.apiRequest(
          "POST",
          `/user-journals/get-custom-detail`,
          payload,
        );
        const response = await JournalApi.getCustomJournalDetail(payload);
        apiLogger.apiResponse(
          "POST",
          `/user-journals/get-custom-detail`,
          response.data,
          200,
        );
        return response.data;
      } catch (error) {
        apiLogger.apiError(
          "POST",
          `/user-journals/get-custom-detail`,
          error,
          error.response?.status,
        );
        throw error;
      }
    },
  });
};
